import { Routes } from "@angular/router";
import { InvoiceReviewSummaryComponent } from "./invoice-review-summary/invoice-review-summary.component";
import { InvoiceReviewOrderTrackingLineComponent } from "./invoice-review-order-tracking-line/invoice-review-order-tracking-line.component";

import { InvoiceReviewBillingNotesListingComponent } from "./invoice-review-billing-notes-listing/invoice-review-billing-notes-listing.component";
import { InvoiceReviewComponent } from "./invoice-review.component";

export const invoiceReviewRoutes: Routes = [
  { path: "", component: InvoiceReviewComponent },
  {
    path: "invoice-review-summary/:id/:projId",
    component: InvoiceReviewSummaryComponent,
  },
  {
    path: "invoice-review-tracking-detail/:id",
    component: InvoiceReviewOrderTrackingLineComponent,
  },
  {
    path: "order-notes/:id",
    component: InvoiceReviewBillingNotesListingComponent,
  },
];
